module.exports = __webpack_public_path__ + "img/fair.65ec2e25.png";